module.exports = __webpack_public_path__ + "static/img/A30.11934f12.jpg";